<template>
  <div class="header">
    <img class="logo-info" :src="logo" @click="backHome" />
    <div class="user-info" @click="loginHandle" v-if="!userStore?.isLogin">
      <img :src="headImg" />
      <span>登录</span>
    </div>
    <div class="user-info" v-else>
      <el-dropdown trigger="click" size="large">
        <span class="el-dropdown-link">
          <img :src="userStore?.userInfo.avatar || headImg" />
          <span>{{ userStore?.userInfo.nickname }}</span
          ><el-icon class="el-icon--right" color="#0D59FA" size="1.4rem"
            ><arrow-down
          /></el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu class="custom-dropdown">
            <el-dropdown-item class="custom-item" @click="toPersonCenter">
              <div class="item-left">
                <img :src="userIcon" />
                <span>个人中心</span>
              </div>
              <el-icon color="#999999" size="1.4rem"
                ><ArrowRightBold
              /></el-icon>
            </el-dropdown-item>
            <el-dropdown-item class="custom-item" @click="logOutHandle">
              <div class="item-left">
                <img :src="logOut" />
                <span>退出登录</span>
              </div>
              <el-icon color="#999999" size="1.4rem"
                ><ArrowRightBold
              /></el-icon>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
  <!-- <el-dialog v-model="tipOpen" title="是否要跳转到科技日报小程序" width="30%">
  </el-dialog> -->
  <router-view />
</template>
<script lang="ts" setup>
import { ref, onMounted, watch, version } from "vue";
import { useRouter } from "vue-router";
import { versions } from "@/utils/utils";
import routerTree from "@/router/config";
import userInfoStore from "@/store/index";
import headImg from "@/assets/head_img.png";
import logo from "@/assets/logo.png";
import userIcon from "@/assets/user_icon.png";
import logOut from "@/assets/log_out.png";
import api from "@/services/index";
const router = useRouter();
const userStore = userInfoStore();
const tipOpen = ref(false);
console.log("userStore", userStore.isLogin, userStore.userInfo);
//返回主页
const backHome = () => {
  window.location.href = "https://www.stdaily.com";
};
//跳转个人中心
const toPersonCenter = () => {
  router.push(routerTree.personCenter.main); // 跳转到个人中心
};
//登录
const loginHandle = () => {
  router.push(routerTree.login); // 跳转到登录
};
//退出登录
const logOutHandle = () => {
  localStorage.removeItem("token");
  userStore.isLogin = false;
  userStore.userInfo = {};
  router.push(routerTree.login);
};

//获取用户个人信息
const getUserInfo = async () => {
  try {
    const res = await api.login.getUserInfo({});
    if (res.status == 200) {
      localStorage.setItem("userInfo", JSON.stringify(res.obj));
      userStore.isLogin = true;
      userStore.userInfo = res.obj;
    }
  } catch (err) {
    console.log("err", err);
  }
};

onMounted(() => {
  console.log("version1", versions());
  // if (versions().isIOS || versions().isAndroid || versions().isHarmony) {
  //   tipOpen.value = true;
  // }
  const token = localStorage.getItem("token");
  if (token) {
    getUserInfo();
  }
});
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 4.9rem;
  background: #ffffff;
  .logo-info {
    width: 8.3rem;
    height: 3.5rem;
    line-height: 3.5rem;
    margin-left: 17.2rem;
  }
  .user-info,
  .el-dropdown-link {
    display: flex;
    align-content: center;
    min-width: 4rem;
    height: 2.6rem;
    line-height: 2.6rem;
    margin-right: 17.2rem;
    cursor: pointer;
    img {
      width: 2.6rem;
      height: 2.6rem;
      border-radius: 50%;
    }
    span {
      min-width: 1rem;
      height: 100%;
      line-height: 2.6rem;
      font-size: 1.2rem;
      font-weight: 600;
      margin: 0 0.7rem;
    }
  }
  .el-dropdown-link {
    margin-right: 0rem;
    .el-icon {
      margin-top: 0.4rem;
      font-weight: 600;
      font-size: 1.4rem !important;
    }
  }
}

.custom-dropdown {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 18rem !important;
  height: auto;
  overflow-x: hidden;
  z-index: 9999;
  .custom-item {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    height: 3.2rem;
    .item-left {
      display: flex;
      align-items: center;
      justify-content: space-around;
      line-height: 3.2rem;
      img {
        width: 1.6rem;
        height: 1.6rem;
      }
      span {
        font-size: 1.2rem;
        font-weight: 600;
        margin: 0 0.7rem;
      }
    }
  }
}
</style>
